import Prompt from '@components/Prompt'
import { Titlebar } from '@components/Titlebar/Titlebar'
import { useWaterNeuron } from '@plug-core/hooks/useStaking'
import { Button, Heading, IconButton, Text } from '@ui'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { HiInformationCircle } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import { WaterNeuronStaking } from './components/Stake'

export const WaterNeuronContainer = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { hasWnError, wnInfo, waterNeuron, icpToken, nicpToken } = useWaterNeuron()

  const [prompt, setPrompt] = useState<{
    title: string
    description: string
  } | null>(null)

  const onInfoClick = (event: any) => {
    setPrompt({
      title: t(`stake.titleAbout`),
      description: t(`stake.about`),
    })
  }

  let content = null
  if (!icpToken || !nicpToken || hasWnError) {
    content = (
      <Heading level={5} align="center" className="mt-20">
        {t('stake.failedToLoadData')}
      </Heading>
    )
  } else if (waterNeuron.current) {
    content = (
      <WaterNeuronStaking
        icpToken={icpToken}
        nicpToken={nicpToken}
        wnInfo={wnInfo}
        waterNeuron={waterNeuron.current}
      />
    )
  }

  return (
    <div className="mb-3 flex flex-col">
      <Titlebar
        onActionClick={() => navigate(-1)}
        leftItem={
          <IconButton
            aria-label={t('stake.titleAbout')}
            className="text-accent"
            onClick={onInfoClick}
          >
            <HiInformationCircle size={20} />
          </IconButton>
        }
      />

      {content}

      <Prompt show={!!prompt} close={() => setPrompt(null)}>
        <div className="flex flex-col items-center gap-2">
          <Heading level={4} align="center">
            {prompt?.title}
          </Heading>
          <Text align="center" tone="fg-2">
            {prompt?.description}
          </Text>
        </div>

        <Button onClick={() => setPrompt(null)} variant="secondary">
          {t('common.understood')}
        </Button>
      </Prompt>
    </div>
  )
}
